import { EMPTY_OBJECT, UPLOAD_API_BASE_URL } from '/src/constants';
import useFetchedData from './useFetchedData';

// Fetches the current user's upload quota for the active period from the upload
// service. Pass `{ enabled: false }` to skip the request (e.g. when upload is
// already disabled for other reasons). The SWR key is shared, so multiple
// callers dedupe to a single request.
export default function useUploadQuota({ enabled = true } = {}) {
  const { data, ...rest } = useFetchedData(
    enabled ? { url: '/videos/quota', baseURL: UPLOAD_API_BASE_URL } : null,
    ({ data } = EMPTY_OBJECT) => data,
  );
  return { quota: data, ...rest };
}
